function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fdd020"
}, /*#__PURE__*/React.createElement("path", {
  d: "m376 240c0 75.109375-60.890625 136-136 136s-136-60.890625-136-136 60.890625-136 136-136 136 60.890625 136 136zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m240 480c-4.417969 0-8-3.582031-8-8v-64c0-4.417969 3.582031-8 8-8s8 3.582031 8 8v64c0 4.417969-3.582031 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m240 80c-4.417969 0-8-3.582031-8-8v-64c0-4.417969 3.582031-8 8-8s8 3.582031 8 8v64c0 4.417969-3.582031 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m120 120-48-48"
}), /*#__PURE__*/React.createElement("path", {
  d: "m120 128c-2.121094 0-4.15625-.84375-5.65625-2.34375l-48-48c-3.03125-3.140625-2.988281-8.128906.097656-11.214844 3.085938-3.085937 8.074219-3.128906 11.214844-.097656l48 48c2.285156 2.289062 2.972656 5.730469 1.734375 8.71875s-4.15625 4.9375-7.390625 4.9375zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m408 408-48-48"
}), /*#__PURE__*/React.createElement("path", {
  d: "m408 416c-2.121094 0-4.15625-.84375-5.65625-2.34375l-48-48c-3.03125-3.140625-2.988281-8.128906.097656-11.214844 3.085938-3.085937 8.074219-3.128906 11.214844-.097656l48 48c2.285156 2.289062 2.972656 5.730469 1.734375 8.71875s-4.15625 4.9375-7.390625 4.9375zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m360 120 48-48"
}), /*#__PURE__*/React.createElement("path", {
  d: "m360 128c-3.234375 0-6.152344-1.949219-7.390625-4.9375s-.550781-6.429688 1.734375-8.71875l48-48c3.140625-3.03125 8.128906-2.988281 11.214844.097656 3.085937 3.085938 3.128906 8.074219.097656 11.214844l-48 48c-1.5 1.5-3.535156 2.34375-5.65625 2.34375zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m472 248h-64c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h64c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m72 248h-64c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h64c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m72 408 48-48"
}), /*#__PURE__*/React.createElement("path", {
  d: "m72 416c-3.234375 0-6.152344-1.949219-7.390625-4.9375s-.550781-6.429688 1.734375-8.71875l48-48c3.140625-3.03125 8.128906-2.988281 11.214844.097656 3.085937 3.085938 3.128906 8.074219.097656 11.214844l-48 48c-1.5 1.5-3.535156 2.34375-5.65625 2.34375zm0 0"
}));

var SvgClearSky = function SvgClearSky(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "0 0 480 480",
    width: "480pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClearSky, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clear-sky.346b346f.svg";
export { ForwardRef as ReactComponent };